<template>
  <div class="LmModalSlider" @click="$emit('click', $event)">
    <lm-material-icon :icon="icon" />
  </div>
</template>

<script>
import LmMaterialIcon from '@/components/ui/LmMaterialIcon'
export default {
  name: 'LmModalSlider',
  components: {LmMaterialIcon},
  props: {
    icon: {
      type: String,
      default: 'navigate_next'
    }
  }
}
</script>

<style scoped>
.LmModalSlider {
  flex-grow: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 60px;
  max-width: 80px;
  height: 80px;
  cursor: pointer;
  &.is-disabled {
    cursor: default;
    .LmMaterialIcon {
      opacity: 0.2;
    }
  }
  &:hover:not(.is-disabled) .LmMaterialIcon {
    background-color: theme('colors.highlight');
  }
  .LmMaterialIcon {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
    border-radius: 100%;
    background-color: #444444;
    color: white;
    transition: background-color 0.2s, opacity 0.3s;
  }
  @media (--mobile) {
    display: none;
  }
}
</style>
